import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface MonitoringGuardProps {
  children: React.ReactNode;
}

/**
 * Guard component to protect the LLM Monitoring page
 * Only allows access to SST and AM users
 */
export const MonitoringGuard: React.FC<MonitoringGuardProps> = ({ children }) => {
  const { user } = useAuth();

  // Check if user has SST or AM role
  const hasMonitoringAccess = user?.roleType === 'SST' || user?.roleType === 'AM';

  if (!hasMonitoringAccess) {
    // Redirect to dashboard if user doesn't have monitoring access
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default MonitoringGuard;